import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Button from 'react-bootstrap/Button';
import FlexCenter from 'App/components/styles/FlexCenter';
import { useUserContext } from 'App/contexts/UserContext';

const ButtonFlex = styled(Button)`
    flex: 1;
`;

const DivFlex = styled('div')`
    flex: 1;
    text-align: center;
`;

const ActionCell = (setActiveBranch, setDefaultBranch) => {
    const ActionCellComponent = ({ row }) => {
        const user = useUserContext();
        const { BranchID: branchId } = user;

        return (
            <FlexCenter>
                {row.original.ID === branchId ? (
                    <DivFlex>Active</DivFlex>
                ) : (
                    <ButtonFlex variant="link" onClick={() => setActiveBranch(row.original.ID)}>
                        Set as Active
                    </ButtonFlex>
                )}
                <ButtonFlex variant="link" onClick={() => setDefaultBranch(row.original.ID)}>
                    Set to default
                </ButtonFlex>
            </FlexCenter>
        );
    };

    ActionCellComponent.propTypes = {
        row: PropTypes.shape({
            original: PropTypes.shape({
                ID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            }).isRequired,
        }).isRequired,
    };

    return ActionCellComponent;
};

export default ActionCell;
